module.exports = __webpack_public_path__ + "./images/355196c5ab99f515d35207d6502b4d77.jpg";